var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-pdp-module-header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/contentful/ugc-pdp-module-header.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <div class=\"c-ugc-pdp-heading\">\n\n            <h3 class=\"c-ugc-pdp-heading__h3\">\n                ";
output += runtime.suppressValue((lineno = 9, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_pdp_heading"])), env.opts.autoescape);
output += "\n            </h3>\n\n            <div class=\"c-ugc-pdp-heading__link-outer\">\n\n                <a href=\"";
output += runtime.suppressValue((lineno = 14, colno = 37, runtime.callWrap(t_4, "categoryUrl", context, ["uo-community"])), env.opts.autoescape);
output += "\" class=\"c-ugc-pdp-heading__a\" data-qa-ugc-view-more>";
output += runtime.suppressValue((lineno = 14, colno = 109, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_pdp_view_more"])), env.opts.autoescape);
output += "</a>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-pdp-module-header.j2"] , dependencies)